<div
  mat-dialog-title
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary=".cdk-overlay-container"
  cdkDragHandle
  class="bg_{{ themeType }} grabbable"
>
  <h6>{{ title }}</h6>
  <button
    mat-icon-button
    mat-dialog-close
    [matTooltip]="display.cache.close"
    type="button"
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <p *ngIf="message">{{ message }}</p>
  <pre>{{ json }}</pre>
</div>

<div
  mat-dialog-actions
  class="border_shadow_top_inset"
>
  <button
    mat-raised-button
    mat-dialog-close
    type="button"
  >{{ display.cache.close }}</button>
</div>
